import { render } from "./ConfirmSignUp.vue?vue&type=template&id=75e4d732"
import script from "./ConfirmSignUp.vue?vue&type=script&lang=ts"
export * from "./ConfirmSignUp.vue?vue&type=script&lang=ts"
script.render = render

export default script